import React, { useEffect, useState } from "react";
import "./Header.scss";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header ${scrolled ? "header--scrolled" : ""}`}>
      <div className="header__inner container">
        <a href="#inicio" className="header__brand" onClick={closeMenu}>
          <div className="header__brand-mark">
            <span>MD</span>
          </div>

          <div className="header__brand-text">
            <h2>Makinaria Dima</h2>
            <p>Maquinaria Industrial</p>
          </div>
        </a>

        <nav className={`header__nav ${menuOpen ? "active" : ""}`}>
          <a href="#inicio" onClick={closeMenu}>
            Inicio
          </a>
          <a href="#nosotros" onClick={closeMenu}>
            Nosotros
          </a>
          <a href="#categorias" onClick={closeMenu}>
            Categorías
          </a>
          <a href="#catalogo" onClick={closeMenu}>
            Catálogo
          </a>
          <a href="#envios" onClick={closeMenu}>
            Envíos
          </a>
          <a href="#contacto" onClick={closeMenu}>
            Contacto
          </a>

          <a
            href="https://wa.me/525515898591"
            target="_blank"
            rel="noopener noreferrer"
            className="header__mobile-cta"
            onClick={closeMenu}
          >
            Solicitar información
          </a>
        </nav>

        <div className="header__right">
          <a
            href="tel:5515898591"
            className="header__phone"
            aria-label="Llamar a Makinaria Dima"
          >
            <span className="header__phone-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 16.92V20C22 20.55 21.55 21 21 21C10.51 21 2 12.49 2 2C2 1.45 2.45 1 3 1H6.09C6.57 1 6.98 1.34 7.07 1.81L7.57 4.81C7.64 5.2 7.5 5.61 7.21 5.89L5.34 7.76C6.56 10.94 9.06 13.44 12.24 14.66L14.11 12.79C14.39 12.5 14.8 12.36 15.19 12.43L18.19 12.93C18.66 13.02 19 13.43 19 13.91V16.92C19 17.47 18.55 17.92 18 17.92H22Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span className="header__phone-text">55 1589 8591</span>
          </a>

          <a
            href={`https://wa.me/525515898591?text=${encodeURIComponent(
              "Hola, me gustaría recibir más información sobre su maquinaria industrial.",
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="header__cta"
          >
            Solicitar información
          </a>

          <button
            className={`header__toggle ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Abrir menú"
            type="button"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
